<template>
  <div>
    <h1 class="common__main-title">Send Mail List</h1>
    <SearchConditions class="search" @changedConditions="changeConditions" />
    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
    </div>

    <div class="mail-list">
      <div class="list-table__title">Mail List</div>
      <MailTable />
    </div>

    <div class="pager-box">
      <PagerComponent v-model="pager"  @changePage="changePage" />
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import PagerComponent from '@/components/parts/Pager.vue'
import MailTable from '@/components/parts/mails/MailTable.vue'
import SearchConditions from '@/components/parts/mails/SearchConditions.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { MailsConditions } from '@/store/mails/types'
import { Pager } from '@/store/pager.types'

export default Vue.extend({
  components: {
    SearchConditions,
    PagerComponent,
    MailTable,
    Loading,
  },

  data: (): {
    isLoading: boolean
    conditions: MailsConditions|null
  } => ({
    isLoading: false,
    conditions: null,
  }),
  computed: {
    pager(): Pager {
      return this.$store.state.mails.pager
    },
  },

  methods: {
    fetch(page: number = 1): void {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      this.$store.dispatch('fetchMails', {
        conditions: this.conditions,
        page,
      })
        .finally(() => {
          this.isLoading = false
        })
    },

    changeConditions(conditions: MailsConditions): void {
      this.conditions = conditions
      this.fetch()
    },

    changePage(page: number): void {
      this.fetch(page)
    },
  },
})
</script>
